import React from 'react';
import { Checkbox } from '@progress/kendo-react-inputs';
import { useAttributeFormBuilder } from '../../../../Hooks/Display/useComponentProperties';
import { useTranslation } from 'react-i18next';

const ColumnColorFormatting = ({ column }) => {

    const { t } = useTranslation([
        "display/components/form"
    ]);

    const [{ steps }, dispatch] = useAttributeFormBuilder();

    const handleToggleColorFormattingColumn = (event) => {
        dispatch.toggleColumnColorFormatting(column.attributeId, event.target.value)
    }

    return (
        <Checkbox
            value={column.cellRules}
            onChange={handleToggleColorFormattingColumn}
            title={t("column.title.color_formatting", { ns: "display/components/form" })}
        />
    );
}

export default ColumnColorFormatting;